import React from "react";
import "../css/styles.css";

const Loading = ({title, Subtitle}) => (
    <div className="loading" style={{height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center',   flexDirection: 'column', gap: '16px'}}>
        {title &&<p className="loader__title">{title}</p>}
        <div className="loader__spinner"></div>
        {Subtitle && <p className="loader__subtitle">
            <Subtitle />
        </p>}
    </div>
);

export default Loading;
